import _str from "shared/util/_str";

export const APPS = {
	likesIncoming: "likesIncoming",
	likesOutgoing: "likesOutgoing",
	intros: "intros",
};

export const EMPTY_STATES = {
	[APPS.likesIncoming]: {
		title: _str("The likes are yet to come!"),
		description: _str("But in the meantime, you should tell us who you like."),
		ctaLink: "/quickmatch",
		ctaText: _str("Play DoubleTake"),
	},

	[APPS.intros]: {
		title: _str("You have no new intros"),
		ctaLink: "/quickmatch",
		ctaText: _str("Go to DoubleTake"),
	},

	[APPS.likesOutgoing]: {
		title: _str("No likes yet!"),
		description: _str("There are a lot of people we think you’ll like. Tap below to check them out."),
		ctaLink: "/quickmatch",
		ctaText: _str("Go to DoubleTake"),
	},
};

export const HEADER_CONFIG = {
	[APPS.likesIncoming]: "likes",
	[APPS.likesOutgoing]: "likes",
	[APPS.intros]: "likes",
};

export const TABS = {
	likes: {
		header: _str("Likes"),
		tabs: [
			{
				app: APPS.likesIncoming,
				title: _str("Likes You"),
				link: "/who-likes-you",
			},
			{
				app: APPS.intros,
				title: _str("Intros"),
				link: "/intros",
			},
			{
				app: APPS.likesOutgoing,
				title: _str("Matches"),
				link: "/who-you-like",
			},
		],
	},

	default: {
		header: "",
		tabs: [
			{
				title: "",
				link: "",
			},
		],
	},
};

export const TAB_INDEXES = {
	"/who-likes-you": 0,
	"/intros": 1,
	"/who-you-like": 2,
};

export const PATHNAMES_TO_APPS = {
	"/who-likes-you": APPS.likesIncoming,
	"/who-you-like": APPS.likesOutgoing,
	"/intros": APPS.intros,
};

// sections within the likesIncoming app
export const LIKES_INCOMING_SECTIONS = {
	theyLikeYou: "theyLikeYou",
	youPassed: "youPassed",
};

// sections within the likesOutgoing app
export const LIKES_OUTGOING_SECTIONS = {
	mutual: "mutual",
	outgoing: "outgoing",
};

// sections within a given page
export const BUCKETS = {
	[APPS.likesIncoming]: {
		[LIKES_INCOMING_SECTIONS.theyLikeYou]: {
			title: _str("Here’s everyone who likes you"),
			subtitle: _str("Like them to start a conversation."),
		},
		[LIKES_INCOMING_SECTIONS.youPassed]: {
			title: _str("You passed on them"),
			subtitle: _str("Give them a second chance."),
		},
	},

	[APPS.intros]: {
		[LIKES_INCOMING_SECTIONS.theyLikeYou]: {
			title: _str("They sent you an intro"),
			subtitle: _str("Like them to start a conversation."),
		},
		[LIKES_INCOMING_SECTIONS.youPassed]: {
			title: _str("You passed on them"),
			subtitle: _str("Give them a second chance."),
		},
	},

	[APPS.likesOutgoing]: {
		[LIKES_OUTGOING_SECTIONS.mutual]: {
			title: _str("You’ve matched"),
			subtitle: _str("Send them a message."),
		},
		[LIKES_OUTGOING_SECTIONS.outgoing]: {
			title: _str("People you like"),
			subtitle: _str("Send an intro message to them!"),
		},
	},
};

export const FREE_USER_INTRO_COPY = {
	title: null,
	subtitle: _str("Upgrade to A-List to see all your intros at once."),
};

export const USERS_PER_PAGE = 20;

export const PROMO_OFFSET = 2;
export const PROMO_EVERY = 30;

export const INTROS_UPGRADE_LINK = "/upgrade?cf=introspage&source=intros";

export const MATCHES_PER_ROW_DESKTOP = 4;
export const MATCHES_PER_ROW_MOBILE = 2;

export const INTROS_PROMO_CLICK_DATA = {
	data: {
		"promo id": "alist.introspage",
		"tapped cta": true,
		interaction: "clicked",
		feature: "alist",
		source: "Intros",
		"feature type": "subscription",
	},
};



// WEBPACK FOOTER //
// ./src/apps/userrows/util/constants.js